import styled from "styled-components"
import { CommonParagraph, CommonSubtitle } from "../Texts"

export const BrandName = styled(CommonSubtitle)`
  font-size: 14px;
  margin-bottom: 0.3em;
`
